import { render, staticRenderFns } from "./DongleRgb.vue?vue&type=template&id=0b572ed8&scoped=true"
import script from "./DongleRgb.vue?vue&type=script&lang=js"
export * from "./DongleRgb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b572ed8",
  null
  
)

export default component.exports